import { updateObject } from '../utils'
import * as actionTypes from '../actions/action-types';

const initialState = {

};

const setDataTableState = (state, action) => {
  const updatedState = { ...state,...action.state };
  return updateObject(state, updatedState);
}

const logout = (state) => {
  return updateObject({}, initialState);
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_DATATABLE_STATE: return setDataTableState(state, action);
    case actionTypes.LOGOUT: return logout(state, action);
    default:
      return state;
  }
};

export default reducer;